import type { Module } from "./schema";

/** Lightweight six-module catalog for the landing route. */
export const modules = [
  {
    id: "M1",
    order: 1,
    title: "党的全面抗战路线和持久抗战方针的制定",
    printPageRange: "73—78",
    pdfPageRange: "93—98",
    sceneIds: ["M1S1", "M1S2"],
    accent: "#c84f3a",
  },
  {
    id: "M2",
    order: 2,
    title: "开展敌后抗日游击战争和坚持统一战线中的独立自主",
    printPageRange: "78—83",
    pdfPageRange: "98—103",
    sceneIds: ["M2S1", "M2S2", "M2S3"],
    accent: "#bd7a35",
  },
  {
    id: "M3",
    order: 3,
    title: "坚持抗战、团结、进步的方针",
    printPageRange: "84—91",
    pdfPageRange: "104—111",
    sceneIds: ["M3S1", "M3S2", "M3S3", "M3S4"],
    accent: "#9c7f4f",
  },
  {
    id: "M4",
    order: 4,
    title: "巩固抗日根据地和推进抗日民主运动",
    printPageRange: "91—97",
    pdfPageRange: "111—117",
    sceneIds: ["M4S1", "M4S2", "M4S3"],
    accent: "#6f8a67",
  },
  {
    id: "M5",
    order: 5,
    title: "加强党的建设、推进马克思主义中国化和开展整风运动",
    printPageRange: "97—103",
    pdfPageRange: "117—123",
    sceneIds: ["M5S1", "M5S2", "M5S3"],
    accent: "#667f8d",
  },
  {
    id: "M6",
    order: 6,
    title: "党的七大和确立毛泽东思想为党的指导思想、抗日战争的最后胜利",
    printPageRange: "103—110",
    pdfPageRange: "123—130",
    sceneIds: ["M6S1", "M6S2", "M6S3"],
    accent: "#a95c52",
  },
] satisfies Module[];
